// extracted by mini-css-extract-plugin
export var alignCenter = "_97-d";
export var bannerShown = "_97-6";
export var buttonContent = "_97-0";
export var cardList = "_97-1";
export var centerContent = "_97-2";
export var chevron = "_97-3";
export var closePanelButton = "_97-k";
export var conversationContextContainer = "_97-l";
export var conversationDetailContainer = "_97-4";
export var detailWrapper = "_97-7";
export var dropdownButton = "_97-e";
export var dropdownTitle = "_97-9";
export var fullHeight = "_97-5";
export var hidden = "_97-a";
export var icon = "_97-b";
export var mergeSuggestionWrapper = "_97-m";
export var panel = "_97-i";
export var portalButtonsWrapper = "_97-c";
export var right = "_97-j";
export var tableSummaryContainer = "_97-8";
export var tableSummaryHeader = "_97-g";
export var threeDotsButton = "_97-f";
export var wide = "_97-h";